var _mask, _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_465_549",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V14.0541V14.2162V20L4.2 16.2162H18C19.1046 16.2162 20 15.3208 20 14.2162V2C20 0.895431 19.1046 0 18 0H2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V14.0541V14.2162V20L4.2 16.2162H18C19.1046 16.2162 20 15.3208 20 14.2162V2C20 0.895431 19.1046 0 18 0H2Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H-1V22.2469L0.669334 20.743L0 20ZM4.2 16.2162V15.2162H3.81598L3.53066 15.4733L4.2 16.2162ZM1 2C1 1.44772 1.44772 1 2 1V-1C0.343146 -1 -1 0.343146 -1 2H1ZM1 14.0541V2H-1V14.0541H1ZM1 14.2162V14.0541H-1V14.2162H1ZM1 20V14.2162H-1V20H1ZM3.53066 15.4733L-0.669334 19.257L0.669334 20.743L4.86933 16.9592L3.53066 15.4733ZM18 15.2162H4.2V17.2162H18V15.2162ZM19 14.2162C19 14.7685 18.5523 15.2162 18 15.2162V17.2162C19.6569 17.2162 21 15.8731 21 14.2162H19ZM19 2V14.2162H21V2H19ZM18 1C18.5523 1 19 1.44772 19 2H21C21 0.343146 19.6569 -1 18 -1V1ZM2 1H18V-1H2V1Z",
    fill: "#333333",
    mask: "url(#path-1-inside-1_465_549)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentFeedback);
export default __webpack_public_path__ + "static/media/comment-feedback.c64d68d3f1596d6487a216e352711c76.svg";
export { ForwardRef as ReactComponent };